import { FAIconTypes } from "~/model/FocusAreasIcons";

export interface LandingContent {
  focusAreas: {
    title: string;
    intro: string;
    areas: {
      title: string;
      content: string;
      icon: FAIconTypes;
      enabled: boolean;
    }[];
  };

  hero: {
    header: string;
    subheader: string;
    description: string;
  };
  howWeDoIt: {
    title: string;
    intro: string;
    steps: {
      title: string;
      content: string;
    }[];
  };
  reasonsToBelieve: {
    title: string;
    quoteOneText: string;
    quoteOneAuthor: string;
    quoteTwoText: string;
    quoteTwoAuthor: string;
  };
  whatWeDo: {
    header: string;
    intro: string;
    advServices: {
      title: string;
      body: string;
    };
    credentialValidation: {
      title: string;
      body: string;
    };
    talentManagement: {
      title: string;
      body: string;
    };
    techCulturalFit: {
      title: string;
      body: string;
    };
    understandReq: {
      title: string;
      body: string;
    };
  };
  whoWeAre: {
    header: string;
    body: string;
  };
}

export const content: LandingContent = {
  focusAreas: {
    title: "Focus Areas",
    intro:
      "Continuous Evolution - that describes Cloud & Hybrid Cloud for sure.  \n\nOur Center of Excellence is all about IT Talent Recruitment that evolves with your business and technology. \n\nOur Core Principles is to keep up with your evolving needs and the depth of Technical Talent you're looking for.  Our Focus Areas are aligned with the top demanded areas of Enterprise and VAR/Service Providers.  Without a doubt, these include:  Cloud-Hybrid Infra, App Dev, DevOps, CyberSecurity, OT/ICT & IOT and nextgen areas like ML/AI. \n",
    areas: [
      {
        title: "Recruitment Center of Excellence",
        content:
          "IT technical talent is our business. Continuously improving our customer service is our passion. \n\nFor over 13 years, Cloud Talent Services has worked with many inspirational and demanding customers.  We are a part of your team - we know your DNA, we know your urgencies and we feel your challenges and successes!\n\nWe transparently integrate into your world, your workflows, your backoffice teams including HR, Legal, Service Delivery Teams and others.  Our alignment with your Technology Talent needs are paramount.  We make it our business, 24/7, to know your DNA and what IT Talent you want/need.  ",
        icon: FAIconTypes.Recruitment,
        enabled: true,
      },
      {
        title: "Cloud-Hybrid Infra",
        content:
          "We get the talent you need across key Infrastructure areas: \n\nOn-prem infra including Data Centers, LAN/WAN/SDWAN/Wireless networks, Servers, Storage, HyperConverged, Workspace Compute and others \n\nCloud Infra including ASW, Azure, GCP, COLO/Hosting Providers, Telco’s//MSO’s and others \n",
        icon: FAIconTypes.HybridInfrastructure,
        enabled: true,
      },
      {
        title: "Application Dev ",
        content:
          "Across the Platforms and environments you work, we get you the talent you need:\n\nFull Stack, Front End, Back End developers\n\nWeb Apps\n\nMobile Apps\n\nSaaS Platforms – ServiceNow, SAP, Workday, etc.\n\nNC/LC - No Code, Low Code\n",
        icon: FAIconTypes.AppDev,
        enabled: true,
      },
      {
        content:
          "Data is critical, manageable data and insightful data is paramount.  We have placed some of the best DBAs, and Data Engineers…\n\nDatabase Admins\n\nDatabase Engineers & Architects\n\nMySQL, SQL, No-SQL, Oracle, AWS, PostgreSQL, DB2, MongoDB, Cassandra, etc.",
        title: "Database",
        icon: FAIconTypes.HybridInfrastructure,
        enabled: true,
      },
      {
        content:
          "Lifecycle Software Development, Pipelines, Workflow Automation, Quality Control – we’re on it: \n\nProvisioning & Config management skills with Chef, Puppet, Ansible, etc. \n\nContinuous integration tools with Jenkins or others \n\nIaC, Container management with Docker, Kubernetes, etc.\n\nCloud Services with AWS EC2, S3, VPC, RDS, Lamda, etc. \n\nMonitoring with Nagios, Splunk, etc. \n\nScripting with Python, PowerShell, UNIX Scripting, etc. ",
        title: "DevOps",
        icon: FAIconTypes.DevOps,
        enabled: true,
      },
      {
        content:
          "CyberSecurity – we understand how critical it is for every organization to prevent, detect and remediate security issues. \n\nPenetration Testers\n\nVulnerability Assessments \n\nIdentity and Access Management, IAM\n\nSecurity Operations Center (SOC) specialists \n\nGovernance & Compliance – NIST, OWASP, ISO, etc.",
        title: "CyberSecurity",
        icon: FAIconTypes.CyberSecurity,
        enabled: true,
      },
    ],
  },
  hero: {
    header: "Specialized Talent Services for North America",
    subheader:
      "We specialize in sourcing talent for IT, Software Development, Artificial Intelligence and other mission critical roles from technical to executive.",
    description:
      "With over 30 years of experience serving small business and large enterprises, we have a proven track record of sourcing talent for the most mission critical roles.\n\n Sit back and lets us find the top talent for your business.",
  },
  howWeDoIt: {
    title: "How We Do It",
    intro:
      "We leverage technology (of course!) but we do it the good ‘ol fashioned way … one candidate at a time ensuring top suitability to you & the candidate.​\n\nOur Cloud Recruiters know tech - languages/scripting, DevOps, CyberSecurity, infrastructure and nextgen like AI/ML, IOT & RPA.\n\nWe take pride in our screening capabilities that deeply explore each candidate’s personality, technical depth and career goals.  And, we help identify and avoid Proxy Fake Candidates with a strict 9 Step Screening Methodology.",
    steps: [
      {
        title: "Job Requirements Analysis",
        content:
          "Learn your corporate DNA, Culture and differentiating Technical requirements for each of your contract job orders or permanent placement roles \n",
      },
      {
        title: "Recruitment Deep Screen",
        content:
          "Apply our proven screening methodology consisting of:\n \nProxyCheck®\n\nCultureFit®\n\nTechCheck®\n\nCandidate Differentiators\n\nSense of Urgency + High Quality Control ",
      },
      {
        title: "Background & Substance Tests",
        content:
          "Upon Candidate Selection, we run: \n\n10 panel Drug & Substance Tests \n\nNational/International Criminal Background Checks",
      },
      {
        title: "Talent Acquired",
        content:
          "Candidate On-boarding:\n\nCredentials, Badging, Training, Work processes\n\nStart work",
      },
    ],
  },
  reasonsToBelieve: {
    title: "Reasons to Believe",
    quoteOneText:
      "Regardless of size and scale, if you need a unique skillset or thought partner on how to execute a technology migration on a tight timeline/budget, Tom can help you make this happen",
    quoteOneAuthor: "Chief Revenue Officer of an MSP",
    quoteTwoText:
      "Very creative thinker who understands our needs and is able to craft solutions that meet those needs. I would recommend Tom based on my experience working with him!​",
    quoteTwoAuthor: "SVP Delivery at a VAR/ITO company",
  },
  whatWeDo: {
    header: "What We Do",
    intro:
      "Being an instrumental part of your Talent Services is our goal. \n\nWe learn your DNA (business, culture, goals) & hand select the right Talent you need.  We Technically & Culturally screen each person so you don’t have to.  \n\nWe’ll only send you 2-3 top profiles … you will hire one of them!​",
    advServices: {
      title: "Advanced Services",
      body: "Delivering SOW based Advanced Services:  \n\nMini Strike Teams\n\nRed Team / Blue Team Security Specialists\n\nAssociate Consulting Program\n\nApplication Development - offshore/nearshore ",
    },
    credentialValidation: {
      title: "Credential Validation",
      body: "We check professional references, validate provided certifications and educational background",
    },
    talentManagement: {
      title: "Talent Management",
      body: "We provide on-going talent & client service management and continuous improvement ",
    },
    techCulturalFit: {
      title: "Technical & Cultural Fit Screening",
      body: "Candidates with the Right Stuff are identified via our 9 Step Talent Screening Methodology.  This includes our proven:\n\nProxyCheck - ensuring no fake candidates or Proxies\n\nTechCheck - asking technical questions pertinent to each technology \n\nCultureFit - creatively discerning how well their personality matches your culture",
    },
    understandReq: {
      title: "Understanding Requirements",
      body: "Successful candidacy starts with truly understanding your company's DNA, team dynamics and the mandatory & preferred skills for each role/job at hand. ",
    },
  },
  whoWeAre: {
    header: "Who We Are",
    body: "We are specialists with Cloud Talent for the Digital Enterprise​\n\n30+ years of experience directly working for & with small-to-large Enterprises & the Channel (VAR, Systems Integrators and MSPs) - we have grown with you and feel your pain. ​\n\nOur evolution has moved with agility and a keen eye to details.  We know what you want and what you need. ​\n\nWe provide top personnel spanning: Cloud Applications, Mobile Dev, DevOps, CyberSec, Infrastructure and Data Analytics, AI/ML/IOT.  We've got you covered. ​\n\nWe are USA owned & operated - we cover coast to coast USA, Canada and Mexico. \n\nRegistered MBE/DBE",
  },
};
